// src/pages/couriers/components/RuleDetails.jsx
import React from 'react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import styles from './RuleDetails.module.css';

const RuleDetails = ({ rules, cities, districts, provinces, shippingZones, shops }) => {
  const { t } = useLocalization();

  const ruleTypes = [
    { key: 'shopRules', label: t('couriers.shopRules'), items: shops, field: 'shopIds', labelField: 'name' },
    { key: 'cityRules', label: t('couriers.cityRules'), items: cities, field: 'cityIds', labelField: 'name' },
    { key: 'shippingZoneRules', label: t('couriers.shippingZoneRules'), items: shippingZones, field: 'shippingZoneIds', labelField: 'name' },
    { key: 'districtRules', label: t('couriers.districtRules'), items: districts, field: 'districtIds', labelField: 'name' },
    { key: 'provinceRules', label: t('couriers.provinceRules'), items: provinces, field: 'provinceIds', labelField: 'name' }
  ];

  return (
    <div className={styles.detailsList}>
      {ruleTypes.map(({ key, label, items, field, labelField }) => {
        const ruleArray = rules[key] || [];
        if (ruleArray.length === 0) return null;
        return (
          <div key={key} className={styles.detailSection}>
            <h4>{label}</h4>
            {ruleArray.map((entry, idx) => {
              const itemNames = entry[field]
                ?.map(id => items.find(item => item.id === id)?.[labelField])
                .filter(Boolean)
                .join(', ') || t('couriers.noRulesConfigured');
              return (
                <div
                  key={idx}
                  className={`${styles.detailEntry} ${
                    entry.type === 'include' ? styles.includeEntry : styles.excludeEntry
                  }`}
                >
                  <span className={styles.entryType}>
                    {entry.type === 'include' ? t('couriers.include') : t('couriers.exclude')}:
                  </span>
                  <span className={styles.entryItems}>{itemNames}</span>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default RuleDetails;